import React, {useEffect, useState} from 'react';
import {useDropzone} from 'react-dropzone';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import IconButton from '@material-ui/core/IconButton';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import { makeStyles } from '@material-ui/core/styles';
import DeleteButton from "./deletebutton";
import { getlanguagelist } from "../../../helpers/changelanguage";
import $ from "jquery";

const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
      backgroundColor: theme.palette.background.paper,
    },
    gridList: {
      width: 500,
      
    },
  }))

const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 16
};

const thumb = {
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: 'border-box'
};

const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden'
};

const img = {
  display: 'block',
  width: 'auto',
  height: '100%'
};

export default function  Dropzone(props) {
 
  let languagelist = getlanguagelist();
  let [files] = useState([]);
  if(props.file_list){
    files = props.file_list
  }
   const {getRootProps, getInputProps} = useDropzone({
   }); 
  const removeImage = (idToremove) => { 

    //$("#list_"+idToremove).remove();
    files.splice(idToremove, 1);
    props.setFileList(files); 
    /* files.splice(idToremove, 1);
    props.setFileList(files); 
    $("#list_"+idToremove).remove(); */
  }

 
    
  
  const fileChange = (e) => {
       Array.from(e.target.files).map((file,index) => {
        if(file.type.includes("image")){
          Object.assign(file, {
            preview: URL.createObjectURL(file),
            path   : file.type.includes("image") ? `promotion/${props.userId}/promotion_image_path` : `promotion/${props.userId}/promotion_video_path`,
          })
  
          let reader = new FileReader();  
          let url    = reader.readAsDataURL(file);
          reader.onloadend = function (e) {
            Object.assign(file, {
              base64 : reader.result
            })
          }
          files.push(file);
          props.setFileList(files); 
        }else{
          var video = document.createElement('video');
          video.preload = 'metadata';
      
          video.onloadedmetadata = function() {
      
              window.URL.revokeObjectURL(video.src);
      
              if (video.duration > 120) {
      
                  ToastsStore.error(languagelist.validvedio);
                  return;
              }
      
              preview(file);
          }
      
          video.src = URL.createObjectURL(file);
        }
      })
      
  }
  const preview = (file) => {
   
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        path   : file.type.includes("image") ? `promotion/${props.userId}/promotion_image_path` : `promotion/${props.userId}/promotion_video_path`,
      })

      let reader = new FileReader();  
      let url    = reader.readAsDataURL(file);
      reader.onloadend = function (e) {
        Object.assign(file, {
          base64 : reader.result
        })
      }
      files.push(file);
      props.setFileList(files); 
  }
  
  const classes = useStyles();
    const thumbs =  
    <GridList cellHeight={160} className={classes.gridList} cols={3}>
        {files.map((file,index) => (
          <GridListTile key={`list_${index}`} cols={1} id={`list_${index}`}>
            {
            (file.type.includes("image")) ? 
              <img src={file.preview} alt={file.name} 
              onError = {(e) => {
                e.target.src = file.base64
              }} 
              
              />
              : 
              <video controls className="video-player" controlsList="nodownload">
                <source src={file.preview} alt={file.name} type={file.type}  onError = {(e) => {
                e.target.src = file.base64
                }} />
                Your browser does not support the video tag.
              </video> 
            }
            {(window.location.href.includes('promotion_preview') == false) ? 
            <GridListTileBar
              title=""
              titlePosition="top"
              actionIcon={
                <DeleteButton removeImage={removeImage} index={index}/>
              }
              actionPosition="right"
            />
            : null
            }
          </GridListTile>
        ))}
        { ((files.length < 5 ) && (window.location.href.includes('promotion_preview') == false))?
            <GridListTile  cols={1}>
               <div {...getRootProps({className: 'dropzone'})} className="video_box">
                <input {...getInputProps()} onChange={fileChange} accept='image/*,video/*'/>
                <img style={{cursor:'pointer', height: '200px'}} src="/assets/images/up_loge_img.jpg" />
              </div>
            </GridListTile>
          : null
        }
    </GridList>
  
  
  useEffect(() => () => {
    // Make sure to revoke the data uris to avoid memory leaks
    files.forEach(file => URL.revokeObjectURL(file.preview));
  }, [files]);

  return (
   
    <section className="container">
     {/*  <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_CENTER} lightBackground />
      */} 
      {
        (files.length) > 0 ?
        <aside style={thumbsContainer}>
            {thumbs}
            
        </aside>
        : 
        (window.location.href.includes('promotion_preview') == false) ? 
        <div {...getRootProps({className: 'dropzone'})} >
          <input {...getInputProps()} onChange={fileChange} accept='image/*,video/*'/>
          <img style={{cursor:'pointer'}} src="/assets/images/up_loge_img.jpg" />
         {/*  <p style={{cursor:'pointer'}}>{languagelist.selectfile} <i className="fa fa-asterisk mandatory-field" aria-hidden="true"></i></p> */}
        </div>
        : null
       
       
      }
    </section>
  );
}


/* {(window.location.href.includes('promotion_preview') == false) ? 
<div {...getRootProps({className: 'dropzone'})}>
  <input {...getInputProps()} onChange={fileChange} accept='image/*,video/*'/>
  <p style={{cursor:'pointer'}}>{languagelist.selectfile} <i className="fa fa-asterisk mandatory-field" aria-hidden="true"></i></p>
</div>
: null
} */

